import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation ,useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const OtherMaster = () => {
  const names = ['Food & Beverages', 'Amenities Master', 'Events Master', 'Enquiry Source',
    'Digital Media Type', 'Media Name Master'];

    const location = useLocation();
    const navigate = useNavigate();
    const permissions = useSelector(selectPermissions);
    const hasModulePermission = (moduleName) => {
      const modulePermission = permissions.find(
        permission => permission.ModuleName === moduleName
      );
      
      if (!modulePermission) return false;
  
      return (
        modulePermission.AddRec === "1" ||
        modulePermission.EditRec === "1" ||
        modulePermission.DeleteRec === "1" ||
        modulePermission.ViewRec === "1"
      );
    };
  

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container sx={{
        '& .MuiGrid-root': {
          width: 'calc(90% + 16px)'
        }
      }}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
          {hasModulePermission("Food & Beverages") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
               // link={{ pathname: '/masters/residenttable' }}
               permissions={permissions}
              title="Food & Beverages"
            />)}
            {hasModulePermission("Events Master") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
               // link={{ pathname: '/masters/residenttable' }}
               permissions={permissions}
              title="Events Master"
            />)}
            {hasModulePermission("Enquiry Source") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
               // link={{ pathname: '/masters/residenttable' }}
               permissions={permissions}
              title="Enquiry Source"
            />)}
            {hasModulePermission("Digital Media Type") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
               // link={{ pathname: '/masters/residenttable' }}
               permissions={permissions}
              title="Digital Media Type"
            />)}
            
          </Grid>
          <Grid container spacing={1} sx={{ mt: 0 }}>
          {hasModulePermission("Media Name Master") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
               // link={{ pathname: '/masters/residenttable' }}
               permissions={permissions}
              title="Media Name Master"
            />)}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default OtherMaster;